<template>
  <div class="row">
    <div 
      v-for="type in types" 
      :key="type.id" 
      class="col-xs-12 col-sm-4">
      <div class="box p-a">
        <transition 
          name="fade" 
          mode="out-in">
          <div 
            key="content" 
            class="content">
            <div class="pull-left m-r">
              <span :class="type.class">
                <i 
                  class="material-icons" 
                  v-html="type.icon"/>
              </span>
            </div>
            <div class="clear">
              <span>
                <h4 class="m-a-0 text-lg _300">
                  <span v-if="!loading && type.type == 'money'">{{ Currency }} {{ new Intl.NumberFormat('en', {minimumFractionDigits: 2}).format(type.total) }}</span>
                  <span v-else-if="!loading">{{ type.total }}</span>
                  <small 
                    v-show="loading" 
                    class="text-xs"><i class="fa fa-spinner fa-spin fa-2x"/></small>
                </h4>
              </span>
              <small class="text-muted">{{ type.name }}</small>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
  
<script>
import Laravel from '../../laroute';
import { mapGetters } from 'vuex';

export default {
    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
        selectedStatuses: {
            type: Array,
            default: () => [],
        },
        selectedApps: {
            type: Array,
            default: () => [],
        },
        selectedOutlets: {
            type: Array,
            default: () => [],
        },
        selectedFilters: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            loading: true,
            types: [
                {
                    id: 'total_sales',
                    name: 'Total Sales',
                    total: null,
                    class: 'w-48 rounded accent',
                    icon: '&#xe227;',
                    type: 'money',
                },
                {
                    id: 'pending_payment',
                    name: 'Pending Payment',
                    total: null,
                    class: 'w-48 rounded primary',
                    icon: '&#xe8a1;',
                    type: 'number',
                },
                {
                    id: 'total_station',
                    name: 'Total Station',
                    total: null,
                    class: 'w-48 rounded warn',
                    icon: '&#xe8de;',
                    type: 'number',
                },
            ],
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),

        outlet() {
            return this.$store.getters.activeOutlet;
        },

        api() {
            return Laravel.route('franchise.subscription.stats');
        },
    },

    watch: {
        outlet() {
            this.getStats();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.getStats();
        },

        selectedFilters: {
            handler() {
                this.getStats();
            },
            deep: true,
            immediate: true,
        },
    },

    mounted() {
        this.getStats();
    },

    methods: {
        getStats() {
            this.loading = true;

            let options = {
                outlet_id: this.outlet,
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                app_id: this.selectedApps.map(item => item.id),
                outlets: this.selectedOutlets.map(item => item.id),
                status: this.selectedStatuses.map(item => item.id),
                filters: this.selectedFilters,
            };

            this.$http.get(this.api, { params: options }).then(response => {
                var data = response.data;

                this.types = this.types.map(obj => {
                    obj.total = data[obj.id];

                    return obj;
                });

                this.loading = false;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/subscription/subscription-stats.vue